import { render, staticRenderFns } from "./XvisorVersion.vue?vue&type=template&id=b3a7129c&"
import script from "./XvisorVersion.vue?vue&type=script&lang=js&"
export * from "./XvisorVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports